import * as React from 'react';
import { UserState } from '../../../interface/MyInterfaces';
import { VendorReportState2025, VendorReportAction2025, UserVendorReportState } from '../../../interface/VendorReportInterface2025';
import { selectedYearChange2025, getPossessiveInstitutionName, getInstitutionName } from '../../../actions/VendorReportActions2025';
import { NewVendorProfile, VENDOR_PROFILE_TAB1_ALL_DATA } from '../../../interface/VendorReportInterface2025';
import renderHTML from 'react-render-html';
import "./ProfileTab.css";
import { ImpactLineChart } from './ImpactLineChart'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, CartesianGrid, Tooltip, Legend } from 'recharts'
import { connect } from 'react-redux';
import { ApplicationState } from '../../../reducers/Index';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { exportVendorChart } from './NewVendorReportButtonHelpers2025';
import { percentageFormat, makeNiceRechartsAxisMulti, isAllIris } from '../../Common/Helpers';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';

class NewVendorTab1First2025 extends React.Component<VendorReportState2025 & UserState & VendorReportAction2025 & UserVendorReportState, NewVendorProfile> {
    constructor(props) {
        super(props);
        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();
        this.state = { currentDateTime: currentDate };
    }

    render() {
        let allData = this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorProfileTab1AllData;
        let yearRangeBullets = this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.highlightsYearRange;
        let topDescription = this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.topDescription;
        let highlights = this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.highlights;

        // Extract data for all 6 line charts
        let nationalEstablishmentsByYear = [];
        let nationalSpendingByYear = [];
        let instateEstablishmentsByYear = [];
        let instateSpendingByYear = [];
        let smallBusinessEstablishmentsByYear = [];
        let smallBusinessSpendingByYear = [];
        const rows = (allData ?? [])
            .filter(r => r.start_fy === r.end_fy)
            .slice()
            .sort((a, b) => +a.start_fy - +b.start_fy);

        for (const item of rows) {
            nationalEstablishmentsByYear.push({year: item.start_fy, establishmentCount: item.national_vendors});
            nationalSpendingByYear.push({year: item.start_fy, spending: item.national_spending});
            instateEstablishmentsByYear.push({year: item.start_fy, establishmentCount: item.in_state_vendors});
            instateSpendingByYear.push({year: item.start_fy, spending: item.in_state_spending});
            smallBusinessEstablishmentsByYear.push({year: item.start_fy, establishmentCount: item.small_business_vendors});
            smallBusinessSpendingByYear.push({year: item.start_fy, spending: item.small_business_spending});
        }

        // Extract data for benchmarking bar chart
        const benchmarkRow: VENDOR_PROFILE_TAB1_ALL_DATA | undefined =
            allData?.find(
                (item) => item.start_fy === item.end_fy && item.start_fy === this.props.selected_year
            );
        const benchmarkChartData = [
            { metric: 'In-State Vendor Count', thisInstitution: benchmarkRow?.in_state_vendor_pct, allIris: benchmarkRow?.in_state_vendor_pct_iris }, 
            { metric: 'In-State Vendor Spending', thisInstitution: benchmarkRow?.in_state_spending_pct, allIris: benchmarkRow?.in_state_spending_pct_iris },
            { metric: 'Small Business Vendor Count', thisInstitution: benchmarkRow?.small_business_vendor_pct, allIris: benchmarkRow?.small_business_vendor_pct_iris },
            { metric: 'Small Business Vendor Spending', thisInstitution: benchmarkRow?.small_business_spending_pct, allIris: benchmarkRow?.small_business_spending_pct_iris},
        ];

        const minYear = this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.minYear;
        const maxYear = this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.maxYear;
        const isAllIrisAgg = isAllIris(this.props.VendorReportState2025?.institutionName || this.props.VendorReportState2025?.HomeState?.campusname);

        const uniqueYears = Array.from(
            new Set((allData ?? []).map(r => Number(r.start_fy))) // numbers only
        )
            .filter(Number.isFinite)
            .sort((a, b) => b - a)
            .map(y => ({ value: y, label: String(y) }));

        const benchmarkAxis = makeNiceRechartsAxisMulti(
            benchmarkChartData,
            ['thisInstitution', 'allIris'] as const,
            6, 0.05, true, true
        );

        return <div className='boxshadow-div'>
            <div className='row'>
                <div className="col-md-12" style={{ fontSize: '16px' }}>
                    {(this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.topDescription) &&
                        renderHTML(`${topDescription}`)
                    }
                    {/*{this.renderAboutBullets()}*/}
                    <h3><b>Highlights</b></h3>
                    <p>
                        {(this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.highlights) &&
                            renderHTML(`${this.props.VendorReportState2025.VendorReport_Tab12025.highlights}`)
                        }
                    </p>
                </div>
            </div>
            <div className='row' style={{ "overflow": "none" }}>
                <div className="col-md-6" style={{ "marginTop": "0", "marginBottom": "0" }}>
					<h2>Vendor Impact FY {minYear} - {maxYear}</h2>
                    {(this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.highlightsYearRange) && 
                        renderHTML(`${this.props.VendorReportState2025.VendorReport_Tab12025.highlightsYearRange}`)
                    }
                </div>
                <div className="col-md-6" style={{ "marginTop": "0", "marginBottom": "0" }}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
                        <h2 style={{ margin: 0, marginRight: 10, whiteSpace: 'nowrap' }}>Vendor Impact FY</h2>
                        <Select
                            name="vendor_selected_year"
                            value={{ value: this.props.VendorReportState2025.selected_year, label: this.props.VendorReportState2025.selected_year }}
                            options={uniqueYears}
                            onChange={(selectedOption) =>
                                this.props.selectedYearChange2025?.(
                                    selectedOption?.value,
                                    this.props.VendorReportState2025?.VendorProfileTab1AllData,
                                    this.props.VendorReportState2025.HomeState?.campusname,
                                    this.props.VendorReportState2025.HomeState?.statename,
                                    this.props.agg
                                )
                            }
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                container: (base) => ({ ...base, flex: 1, minWidth: 0, fontSize: '16px'  }),
                                singleValue: (base) => ({ ...base, fontSize: '2rem' }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999, fontSize: '16px' })
                            }}
                            />
                    </div>
                    {(this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.highlightsSelectedYear) && 
                        renderHTML(this.props.VendorReportState2025.VendorReport_Tab12025.highlightsSelectedYear)
                    }                
                </div>
                {/*<div>loading <i className="fa fa-spinner"></i></div>*/}
            </div>
            <div className='row'>
                <div className="col-md-12" >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <a className="export" onClick={
                            () => exportVendorChart(
                                "#national",
                                "national.png",
                                this.props.UserState.display_id,
                                this.state.currentDateTime,
                                this.props.UserState.university,
                                this.props.UserState.report_vintage_vendor2025,
                                this.props.report_vintage_vendor2025)}>
                            <i className="fa fas fa-download new-vendor-report"></i>EXPORT CHART
                        </a>
                        <span tabIndex={1}
                            data-tip="Hover or click on the data points in this chart to view the total dollars spent and the number of vendors supported in that year."
                            data-for="nationalChartToolTip"
                            data-class="vendorReportChartToolTipStyling"
                            style={{ marginLeft: 'auto', color: 'gray' }}>
                            <span className='help'>
                                <i className="fa fa-info-circle fa-lg zoomhelp-icon"></i>Info
                            </span>
                        </span>
                        <ReactTooltip id="nationalChartToolTip" multiline={true} />
                    </div>
                    {nationalEstablishmentsByYear && nationalSpendingByYear &&
                        <div className="national" id="national">
                            <ImpactLineChart
                                establishmentsByYear={nationalEstablishmentsByYear}
                                spendingByYear={nationalSpendingByYear}
                                UserState={this.props.UserState}
                                chartLabel='National'
                                chartNum='impactChart1'
                                syncId="nationalTooltips"
                                selectedYear={this.props.VendorReportState2025?.selected_year}
                            />
                        </div>
                    }
                </div>
            </div>
            <div className='row'>
                <div className="col-md-12" >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <a className="export" onClick={
                            () => exportVendorChart(
                                "#instate",
                                "instate.png",
                                this.props.UserState.display_id,
                                this.state.currentDateTime,
                                this.props.UserState.university,
                                this.props.UserState.report_vintage_vendor2025,
                                this.props.report_vintage_vendor2025)}>
                            <i className="fa fas fa-download new-vendor-report"></i>EXPORT CHART
                        </a>
                        <span tabIndex={1}
                            data-tip="Hover or click on the data points in this chart to view the total dollars spent and the number of vendors supported in that year."
                            data-for="instateChartToolTip"
                            data-class="vendorReportChartToolTipStyling"
                            style={{ marginLeft: 'auto', color: 'gray' }}>
                            <span className='help'>
                                <i className="fa fa-info-circle fa-lg zoomhelp-icon"></i>Info
                            </span>
                        </span>
                        <ReactTooltip id="instateChartToolTip" multiline={true} />
                    </div>
                    {instateEstablishmentsByYear && instateSpendingByYear &&
                        <div className="instate" id="instate">
                            <ImpactLineChart
                                establishmentsByYear={instateEstablishmentsByYear}
                                spendingByYear={instateSpendingByYear}
                                UserState={this.props.UserState}
                                chartLabel='In-State'
                                chartNum='impactChart2'
                                syncId="instateTooltips"
                                selectedYear={this.props.VendorReportState2025?.selected_year}
                            />
                        </div>
                    }
                </div>
            </div>
            <div className='row'>
                <div className="col-md-12" >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <a className="export" onClick={
                            () => exportVendorChart(
                                "#smallbusiness",
                                "smallbusiness.png",
                                this.props.UserState.display_id,
                                this.state.currentDateTime,
                                this.props.UserState.university,
                                this.props.UserState.report_vintage_vendor2025,
                                this.props.report_vintage_vendor2025)}>
                            <i className="fa fas fa-download new-vendor-report"></i>EXPORT CHART
                        </a>
                        <span tabIndex={1}
                            data-tip="Hover or click on the data points in this chart to view the total dollars spent and the number of vendors supported in that year."
                            data-for="smallBusinessChartToolTip"
                            data-class="vendorReportChartToolTipStyling"
                            style={{ marginLeft: 'auto', color: 'gray' }}>
                            <span className='help'>
                                <i className="fa fa-info-circle fa-lg zoomhelp-icon"></i>Info
                            </span>
                        </span>
                        <ReactTooltip id="smallBusinessChartToolTip" multiline={true} />
                    </div>
                    {smallBusinessEstablishmentsByYear && smallBusinessSpendingByYear &&
                        <div className="smallbusiness" id="smallbusiness">
                            <ImpactLineChart
                                establishmentsByYear={smallBusinessEstablishmentsByYear}
                                spendingByYear={smallBusinessSpendingByYear}
                                UserState={this.props.UserState}
                                chartLabel='Small Business'
                                chartNum='impactChart3'
                                syncId="smallBusinessTooltips"
                                selectedYear={this.props.VendorReportState2025?.selected_year}
                            />
                        </div>
                    }
                </div>
            </div>
            <br></br><br></br>

            <div>
                <div className='row'>
                    <div className="col-md-12" style={{ fontSize: '16px' }}>
                    <h3><b>{!isAllIrisAgg ? `IRIS Member Benchmarking` : `Annual Impact`}</b></h3>
                        {(this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.benchmarkingDescription) &&
                            renderHTML(`${this.props.VendorReportState2025.VendorReport_Tab12025.benchmarkingDescription}`)
                        }
                        <br></br><br></br>
                        <b>FY {this.props.VendorReportState2025.selected_year} Highlights:</b>
                        <br></br>
                        {(this.props.VendorReportState2025 && this.props.VendorReportState2025.VendorReport_Tab12025.benchmarkingHighlights) &&
                            renderHTML(`${this.props.VendorReportState2025.VendorReport_Tab12025.benchmarkingHighlights}`)
                        }
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-12" >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <a className="export" onClick={
                                () => exportVendorChart(
                                    "#benchmarking",
                                    "benchmarking.png",
                                    this.props.UserState.display_id,
                                    this.state.currentDateTime,
                                    this.props.UserState.university,
                                    this.props.UserState.report_vintage_vendor2025,
                                    this.props.report_vintage_vendor2025)}>
                                <i className="fa fas fa-download new-vendor-report"></i>EXPORT CHART
                            </a>
                            <span tabIndex={1}
                                data-tip="Use the drop-down menu in the Vendor Impact section to change the selected year."
                                data-for="benchmarkingChartToolTip"
                                data-class="vendorReportChartToolTipStyling"
                                style={{ marginLeft: 'auto', color: 'gray' }}>
                                <span className='help'>
                                    <i className="fa fa-info-circle fa-lg zoomhelp-icon"></i>Info
                                </span>
                            </span>
                            <ReactTooltip id="benchmarkingChartToolTip" multiline={true} />
                        </div>
                        <div className="benchmarking" id="benchmarking">
                            <h5 style={{ textAlign: "center", marginBottom: 8 }} >{!isAllIrisAgg ? `IRIS Member Benchmarking` : `Percentage of Vendors and Spending by In-State and Small Businesses`}</h5>
                            <ResponsiveContainer width="100%" height={!isAllIrisAgg ? 400 : 290}>
                                <BarChart data={benchmarkChartData} layout={"vertical"} margin={{ left: 60 }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis
                                        type="number"
                                        domain={benchmarkAxis.domain}
                                        ticks={benchmarkAxis.ticks}
                                        tickFormatter={(v) => `${v}%`}
                                    />
                                    <YAxis type="category" dataKey="metric" interval={0} width={100} tick={{ fontSize: '1.5rem', fill: 'black' }} />
                                    <Bar dataKey="thisInstitution" fill="#008000" name={this.props.VendorReportState2025.institutionName} ></Bar>
                                    {!isAllIrisAgg && <Bar dataKey="allIris" fill="#cfc793" name="All IRIS"></Bar>}
                                    <Tooltip labelStyle={{ padding: 0 }}
                                        itemStyle={{ color: "#000" }}
                                        formatter={(value) => value + '%'} />
                                    <Legend verticalAlign="top" align="right" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
                {/*</div>}*/}
            </div>
        </div>
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    VendorReportState2025: state.vendorReportProperties2025,
    SpendingReportState: state.spendingReportProperties
});

const matchDispatchToProps = { selectedYearChange2025, getPossessiveInstitutionName, getInstitutionName };

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(NewVendorTab1First2025, "Vendor Profile Report", "first tab"));
